<template>
  <tr>
    <td>
      <v-layout column>
        <small class="mb-1 max-w-text">
          {{ capitalizeFirstLetter(orderListItem.Code) }}</small
        >
        <v-avatar
          size="32"
          v-if="orderListItem.ColorId"
          :color="getRandomColor"
        >
        </v-avatar>
      </v-layout>
    </td>

    <td
      v-for="(availableSize, indexOf) in isCartItem
        ? availableSizes
        : orderListItem.Stock"
      :key="indexOf"
    >
      <v-col
        cols="12"
        v-if="isAvailble(availableSize.Size, orderListItem.Stock)"
        class="d-flex flex-column align-center"
      >
        <counterItem
          :item="orderListItem"
          :amount="
            isCartItem
              ? findReserved(orderListItem.Reserved, availableSize)
              : findReserved(orderListItem.Stock, availableSize)
          "
          :productCode="productCode"
          :ref="
            'counter' + availableSize.Size + orderListItem.Code + productCode
          "
          :size="availableSize.Size"
          :isStockItem="true"
          @amountChangeStock="amountChangeStock"
        />
      </v-col>
      <v-col v-else cols="12" class="d-flex flex-column align-center">
        <template v-if="isAvailble(availableSize.Size, orderListItem.Reserved)">
          <counterItem
            :item="orderListItem"
            :amount="
              isCartItem
                ? findReserved(orderListItem.Reserved, availableSize)
                : findReserved(orderListItem.Stock, availableSize)
            "
            :productCode="productCode"
            :ref="
              'counter' + availableSize.Size + orderListItem.Code + productCode
            "
            :size="availableSize.Size"
            :isStockItem="false"
            :isReservedItem="true"
            @amountChangeReserved="amountChangeReserved"
          />
        </template>

        <template v-else-if="!orderListItem || isCartItem">
          <counterItem
            :item="orderListItem"
            :amount="
              isCartItem
                ? findReserved(orderListItem.Reserved, availableSize)
                : findReserved(orderListItem.Stock, availableSize)
            "
            :productCode="productCode"
            :ref="
              'counter' + availableSize.Size + orderListItem.Code + productCode
            "
            :size="availableSize.Size"
            @amountUpReservedNew="amountUpReservedNew"
          />
        </template>
        <template v-else>
          <v-layout align-center column>
            <v-btn :disabled="true" icon>
              <v-icon small>mdi-chevron-up</v-icon>
            </v-btn>
            <v-layout align-center column>
              <input
                :readonly="true"
                value="0"
                type="number"
                class="inputwidth text--center ma-0 pa-0 inputborderRed"
              />
            </v-layout>
            <v-btn :disabled="true" icon>
              <v-icon small>mdi-chevron-down</v-icon>
            </v-btn>
          </v-layout>
        </template>
      </v-col>
    </td>
    <td v-if="!isCartItem">
      <v-layout align-center>
        {{ orderAmount }}
      </v-layout>
    </td>
    <td v-if="isCartItem">
      <v-layout align-center>
        {{ getBasketReservedAmount }}
      </v-layout>
    </td>
    <td v-if="isCartItem">
      <v-btn fab icon small @click="deleteItem(orderListItem)">
        <v-icon> mdi-close</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
  
  <script>
import request from "@/request";
import counterItem from "../fashion/CountItem.vue";

export default {
  props: [
    "orderListItem",
    "isCartItem",
    "productCode",
    "stockItems",
    "availableSizes",
    "customerId",
  ],
  data() {
    return {
      show: [],
      allSizes: [],
      amount: [],
      apiUrl: this.$config.apiUrls.Dev,
      images: [],
      cart: [],
      snackbar: false,
      snackbarText: null,
      timeout: 4000,
      snackbarColor: null,
      index: null,
      basketReservedAmount: null,
      customerIdParent: this.customerId,
    };
  },
  components: {
    counterItem,
  },
  created() {
    this.setOrderItem();
  },
  watch: {
    orderListItem: function () {
      this.setOrderItem();
    },
    cart: function () {
      this.$emit("cartItems", this.cart);
    },
  },
  computed: {
    getRandomColor() {
      const colors = [
        { Id: "1", Image: "#F44336" },
        { Id: "2", Image: "#E91E63" },
        { Id: "3", Image: "#9C27B0" },
        { Id: "4", Image: "#673AB7" },
        { Id: "5", Image: "#3F51B5" },
        { Id: "6", Image: "#2196F3" },
        { Id: "7", Image: "#03A9F4" },
        { Id: "8", Image: "#00BCD4" },

        { Id: "9", Image: "#009688" },
        { Id: "10", Image: "#4CAF50" },
        { Id: "11", Image: "#8BC34A" },
        { Id: "12", Image: "#CDDC39" },
        { Id: "13", Image: "#FFEB3B" },
        { Id: "14", Image: "#FFC107" },
        { Id: "15", Image: "#FF9800" },
        { Id: "16", Image: "#FF5722" },
        { Id: "17", Image: "#795548" },
        { Id: "18", Image: "#607D8B" },
        { Id: "19", Image: "#9E9E9E" },
        { Id: "20", Image: "#000000" },
        { Id: "21", Image: "#616161" },
        { Id: "22", Image: "#757575" },
        { Id: "23", Image: "#BDBDBD" },
        { Id: "24", Image: "#EEEEEE" },
      ];
      return colors[Math.floor(Math.random() * colors.length)].Image;
    },
    getcurrency() {
      let currencySign;
      switch (this.currency) {
        case "EUR":
          currencySign = "€ ";
          break;
        case "GBP":
          currencySign = "£ ";
          break;
        case "USD":
          currencySign = "$ ";
          break;

        default:
          currencySign = "€ ";
          break;
      }
      return currencySign;
    },

    orderAmount() {
      let totalAmount = 0;
      if (this.cart.length == 0) {
        return 0;
      }
      this.cart.forEach((element) => {
        element.SizesAmounts.forEach((el) => {
          totalAmount += el.Amount;
        });
      });
      return totalAmount;
    },
    getBasketReservedAmount: {
      get() {
        if (this.basketReservedAmount == null || !this.basketReservedAmount) {
          this.setBasketReservedAmount();
        }
        return this.basketReservedAmount;
      },
      set(item) {
        this.basketReservedAmount = item;
      },
    },
  },
  methods: {
    amountChangeStock(event) {
      if (this.cart.length > 0) {
        this.cart.forEach((el) => {
          if (
            el.VariantCode == event.item.Code &&
            el.ProductId == event.productCode
          ) {
            if (
              el.SizesAmounts.find(
                (sizeElement) => sizeElement.Size == event.size
              )
            ) {
              el.SizesAmounts.find(
                (sizeElement) => sizeElement.Size == event.size
              ).Amount = Number(event.amount);
            } else {
              el.SizesAmounts.push({
                Size: event.size,
                Amount: Number(event.amount),
              });
            }
          } else if (el.ProductId == event.productCode) {
            this.cart.push({
              ProductId: this.productCode,
              VariantCode: event.item.Code,
              SizesAmounts: [
                {
                  Size: event.size,
                  Amount: Number(event.amount),
                },
              ],
            });
          }
        });
      } else {
        this.cart.push({
          ProductId: this.productCode,
          VariantCode: event.item.Code,
          SizesAmounts: [
            {
              Size: event.size,
              Amount: Number(event.amount),
            },
          ],
        });
      }
    },
    amountChangeReserved(event) {
      this.orderListItem.Reserved.forEach((element) => {
        if (element.Size == event.size) {
          element.BasketReservedAmount = event.amount;
        }
      });
      this.updateCart(event.item.Code, event.size, event.amount);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    findReserved(items, size) {
      if (!this.isCartItem) {
        const item = items.find((el) => el.Size == size.name);
        if (item) {
          if (item["BasketReservedAmount"]) {
            return item.BasketReservedAmount;
          }
          return "0";
        }
        return "0";
      }
      const item = items.find((el) => el.Size == size.Size);
      if (!item) {
        return "0";
      }
      if (!item["BasketReservedAmount"]) {
        return "0";
      }
      return item.BasketReservedAmount;
    },
    async setOrderItem() {
      this.images = [];
      if (this.orderListItem.ColorId) {
        if (!this.orderListItem.ColorId.Id) {
          this.orderListItem.ColorId = await this.getColorById(
            this.orderListItem.ColorId
          );
        } else {
          this.orderListItem.ColorId = await this.getColorById(
            this.orderListItem.ColorId.Id
          );
        }
      }
      this.orderListItem.CommercialImages.forEach((element) => {
        if (element) {
          this.images.push(
            this.apiUrl + "/images/products/commercial-images/" + element
          );
        }
      });
    },
    amountUpReservedNew(event) {
      this.updateCart(event.item.Code, event.size, event.amount, true);
    },
    updateCart(code, size, amount, isNewItem = false) {
      let urlFilter = this.customerIdParent
        ? "&customerId=" + this.customerIdParent
        : "";

      request.post(
        "/api/kdesign/basketupdateamount?variantCode=" +
          code +
          "&productId=" +
          this.productCode +
          "&size=" +
          size +
          "&amount=" +
          amount +
          urlFilter,
        null,
        (res) => {
          if (!res.success) {
            this.snackbar = true;
            this.snackbarText = this.$t(
              "Oops something went wrong, please try again."
            );
            this.snackbarColor = "error";
          } else {
            this.$emit("updateTotalPrice");
            isNewItem ? this.$emit("changePrice", "") : "";
            this.setBasketReservedAmount();

            /* this.$emit("changePrice", ""); */
          }
        }
      );
    },
    async getColorById(id) {
      let color;
      if (id) {
        color = ""; /* await axios
          .get(this.apiUrls.Dev + "/api/kdesign/productcolor?colorId=" + id)
          .then((res) => {
            return res.data;
          }); */
        return await color;
      }
      return "";
    },
    isAvailble(size, stock) {
      if (!stock) {
        return false;
      }
      return (
        (stock.find((el) => el.Size == size) != undefined &&
          stock.find((el) => el.Size == size).AvailableAmount != 0) ||
        (stock.find((el) => el.Size == size) != undefined &&
          stock.find((el) => el.Size == size).AvailableAmount == 0 &&
          stock.find((el) => el.Size == size).BasketReservedAmount > 0)
      );
    },
    deleteItem(item) {
      let urlFilter = this.customerIdParent
        ? "&customerId=" + this.customerIdParent
        : "";
      request.post(
        "/api/kdesign/basketremove?productId=" +
          this.productCode +
          "&variantCode=" +
          item.Code +
          urlFilter,
        null,
        (res) => {
          if (res.success) {
            this.$emit("changePrice");
            this.snackbar = true;
            this.snackbarText = this.$t(
              "Item successfully deleted from shopping cart."
            );
            this.snackbarColor = "succes";
          } else {
            this.snackbar = true;
            this.snackbarText = this.$t(
              "Oops something went wrong, please try again."
            );
            this.snackbarColor = "error";
          }
        }
      );
    },

    resetCart() {
      this.availableSizes.forEach((element) => {
        if (
          this.$refs[
            "counter" +
              element.Size +
              this.orderListItem.Code +
              this.productCode
          ]
        ) {
          this.$refs[
            "counter" +
              element.Size +
              this.orderListItem.Code +
              this.productCode
          ][0].reset();
        }
      });
      this.cart = [];
    },
    changeCurrency(currency) {
      if (currency) {
        this.currency = currency;
      }
    },
    correctItemPrice(item) {
      if (!item) {
        return 0;
      }
      let price = 0;
      item.Netprices.forEach((element) => {
        if (element.Code == this.currency) {
          return (price = element.Price);
        }
      });
      return price;
    },
    setBasketReservedAmount() {
      this.basketReservedAmount = 0;
      if (!this.orderListItem) {
        return 0;
      }
      this.orderListItem.Reserved.forEach((element) => {
        this.basketReservedAmount += element.BasketReservedAmount;
      });
      return this.basketReservedAmount;
    },
    updateCutomerId(param) {
      this.customerIdParent = param;
    },
  },
};
</script>
  
  <style scoped>
.v-text-field {
  width: 4rem;
}
.inputborder {
  border: solid 1px;
  border-color: black;
  border-radius: 0.25rem;
}
.inputborderOrange {
  border: solid 1px;
  border-color: orange;
  border-radius: 0.25rem;
}
.inputborderRed {
  border: solid 1px;
  border-color: red;
  border-radius: 0.25rem;
}
.centered-input >>> input {
  text-align: center;
}
.inputhight {
  height: 2rem !important;
  max-width: 1rem;
  text-align: center;
}
.spacer-width {
  width: 1rem !important;
}
.cursor {
  cursor: pointer;
}
.text-color {
  color: #616161;
}
.max-w-text {
  width: 2rem;
}
.inputwidth {
  max-width: 2rem;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>